/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessoResDto } from '../../models/sesso-res-dto';

export interface SessiControllerFindManySessi$Params {}

export function sessiControllerFindManySessi(
  http: HttpClient,
  rootUrl: string,
  params?: SessiControllerFindManySessi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<SessoResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    sessiControllerFindManySessi.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SessoResDto>>;
      }),
    );
}

sessiControllerFindManySessi.PATH = '/sessi';
